
const Menu = () =>{

    return <div>This is Menu</div>
}

export default Menu